export const cartLoading = "cart/loading";
export const cartError = "cart/Error";
export const cartGet = "cart/Get";
export const getSingle = "cart/getSingle";
export const cartSet = "cart/Set";
export const cartDelete = "cart/Delete";
export const cartUpdate = "cart/Update";
